import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { IRefinementListRenderOptions } from '../../models/algolia-refinement-render-options';
import { IAlgoliaRefinementDescriptor } from '../../models/algolia-refinement-descriptor';
import { RefinementListItem } from 'instantsearch.js/es/connectors/refinement-list/connectRefinementList';
import { Form, FormControl } from '@angular/forms';
import { debounce, debounceTime, Subscription } from 'rxjs';
import { materialSymbols } from '../../../../../shared/constants/material-symbols';

@Component({
  selector: 'app-search-refinement',
  standalone: false,
  templateUrl: './search-refinement.component.html',
  styleUrl: './search-refinement.component.scss'
})
export class SearchRefinementComponent implements OnInit, OnDestroy, OnChanges {


  @Input() id: string = 'search-refinement'
  @Input() refinementDescriptor?: IAlgoliaRefinementDescriptor;
  @Input() refinementRenderOptions?: IRefinementListRenderOptions;
  @Input() canExpandRefinement: boolean = true;

  subscriptions: Subscription = new Subscription();

  expanded: boolean = false;
  expandedIconName: string = materialSymbols.keyboardArrowUp;
  collapsedIconName: string = materialSymbols.keyboardArrowDown;

  searchRefinementControl: FormControl = new FormControl('');


  ngOnInit(): void {
    this.setupSearchRefinementSubscription();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['refinementRenderOptions'] && changes['refinementRenderOptions'].currentValue) {
      // Handle changes to refinement render options
      this.refinementRenderOptions = changes['refinementRenderOptions'].currentValue;

      if (this.refinementDescriptor?.isSearchable && !this.refinementRenderOptions?.isFromSearch) {
        // Clear the search input if the refinement options are updated from a non-search event (e.g. user applied a filter, or clicked show more/less)
        this.searchRefinementControl.setValue('', { emitEvent: false });
      }
    }
  }

  onCheckBoxChanged(item: RefinementListItem) {
    if (this.refinementRenderOptions && this.refinementRenderOptions.canRefine ) {
      this.refinementRenderOptions.refine(item.value);
    }
  }

  // Expand or collapse the refinement options.
  toggleExpanded() : void {
    this.expanded = !this.expanded;
  }

  // Toggle Show More/Show Less.  Default is to show 10 items.  Show More will display 20 items.
  toggleShowMore() : void {
    if (this.refinementRenderOptions && this.refinementRenderOptions.canToggleShowMore) {
      this.refinementRenderOptions.toggleShowMore();
    }
  }

  setupSearchRefinementSubscription() : void {
    if (this.refinementDescriptor?.isSearchable && this.refinementRenderOptions?.searchForItems) {
      this.subscriptions.add(this.searchRefinementControl.valueChanges.pipe(
        debounceTime(500)
      )
      .subscribe({
        next: (value: string) => {
          this.refinementRenderOptions?.searchForItems(value);
        }
      }));
    }
  }

}
